import * as React from 'react';
import { InputText } from 'primereact/inputtext';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { UserAdminModel } from "../../models/user/";
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import Translate from '../../common/functions/translate';

interface IProps {
  user: UserAdminModel,
  handleChange: any,
  handleCheckboxChange: any,
}

interface IState {
  validationMessage: string;
}

class UserTabAccountInfo extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      validationMessage: ''
    };
  }

  public render() {
    const { user } = this.props;

    return (
      <div className="p-grid p-fluid p-md-12">
        <div className="p-col-12 p-md-3">
          <label>Last logged on:</label>
          <div>{user.lastLogged ? HelperFunctions.fomatDateTimeAsString(new Date(user.lastLogged)) : ""}</div>
        </div>
        <div className="p-col-12 p-md-3">
          <label>Updated on:</label>
          <div>{user.updatedOn ? HelperFunctions.fomatDateTimeAsString(new Date(user.updatedOn)) : ""}</div>
        </div>
        <div className="p-col-12 p-md-3">
          <label>Created on:</label>
          <div>{user.createdOn ? HelperFunctions.fomatDateTimeAsString(new Date(user.createdOn)) : ""}</div>
        </div>
        <div className="p-col-12 p-md-3">
          <label></label>
          <div className="p-grid p-fluid p-md-12">
            <div className="p-col-12 p-md-6">
              <Checkbox
                inputId="isActive"
                name="isActive"
                checked={user.isActive}
                onChange={(e) => this.props.handleCheckboxChange(e)}
              />
              <label htmlFor="isActive" className="p-checkbox-label">Active</label>
            </div>
          </div>
        </div>
        <div className="p-col-12 p-md-3">
          <label>Name:</label>
          <InputText
            name="name"
            onChange={(e) => this.props.handleChange('name', e.target['value'])}
            value={user && user.name ? user.name : ""}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>Password:</label>
          <InputText
            type="password"
            name="password"
            onChange={(e) => this.props.handleChange('password', e.target['value'])}
            value={user && user.password ? user.password : ""}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>Email:</label>
          <InputText
            name="email"
            onChange={(e) => this.props.handleChange('email', e.target['value'])}
            value={user && user.email ? user.email : ""}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <label>Date of birth:</label>
          <Calendar
            dateFormat="dd.mm.yy г."
            showButtonBar={true}
            //showTime={true}
            // showSeconds={true}
            // hideOnDateTimeSelect={true}
            // disabled={true}
            monthNavigator={true}
            yearNavigator={true}
            yearRange="1950:2050"
            name="birthDate"
            showIcon={true}
            readOnlyInput={true}
            value={user.birthDate ? new Date(user.birthDate) : undefined}
            onChange={(e) => this.props.handleChange('birthDate', e.value)}
          />
        </div>
        {/* <div className="p-col-12 p-md-3">
          <label>Facebook user ID:</label>
          <InputText
            name="facebookUserId"
            onChange={(e) => this.props.handleChange('facebookUserId', e.target['value'])}
            value={user && user.facebookUserId ? user.facebookUserId : ""}
          />
        </div> */}
      </div>
    )
  }
}

export default UserTabAccountInfo;